import Tooltip from '@components/common/Tooltip';

const Chart = () => {
    return (
        <>
            <div className="custom-card card hrm-main-card info">
                <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                        <div className="me-3">
                            <div className="avatar avatar-md rounded-4 bg-info shadow shadow-info text-fixed-white">
                                <i className="ri-bubble-chart-line fs-18"></i>
                            </div>
                        </div>
                        <div className="flex-fill">
                            <p className="mb-1 text-muted">
                                과습
                                <Tooltip
                                    content="도움말이 표시될예정"
                                    customClass="tooltip-dark"
                                    placement="top"
                                >
                                    <i className="ri-question-line" />
                                </Tooltip>
                            </p>
                            <div className="d-flex align-items-top justify-content-between">
                                <h5 className="fw-semibold mb-0 lh-1">높음</h5>
                                <div className="text-info fw-semibold">
                                    0.92
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        role="progressbar"
                        aria-valuenow="65"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        className="progress progress-lg p-1 progress-animate progress"
                    >
                        <div
                            role="progressbar"
                            className="progress-bar progress-bar-striped bg-info progress-bar"
                            aria-valuenow="65"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            style={{ width: '65%' }}
                        ></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Chart;
